import { BASE_URL } from "../../../config/api";
import Default from "../Default.svg";

const IMAGE_EXTS = ["jpg", "jpeg", "png", "gif", "bmp", "svg", "webp"];
const VIDEO_EXTS = ["mp4", "avi", "mov", "wmv", "flv", "mkv", "webm"];

// group / globe / chart / network are the four Create League offers today; the
// rest stay valid so leagues created with the older picker keep their icon.
const VALID_ICON_KEYS = new Set([
  "group",
  "globe",
  "chart",
  "network",
  "trend",
  "trophy",
  "candle",
  "grad",
  "shield",
  "private",
]);
const ICON_MARKER_RE = /<[^>]*data-qushi-icon=["']([a-z]+)["'][^>]*>(?:<\/[^>]+>)?/i;

export const getLeagueMedia = (game) => {
  const imagePath = game?.game_image?.length > 0 ? game.game_image[0].image : null;
  let url = Default;
  let hasUploadedMedia = false;

  if (imagePath) {
    hasUploadedMedia = true;
    if (/^https?:\/\//i.test(imagePath)) {
      // Backend already stored an absolute URL — use as-is so dev/prod hosts work.
      url = imagePath;
    } else {
      const filename = imagePath.split("/").pop();
      url = `${BASE_URL}/storage/upload/game/image/${filename}`;
    }
  }

  const extension = url.split(".").pop().toLowerCase();
  const isVideo = VIDEO_EXTS.includes(extension);
  const isImage = IMAGE_EXTS.includes(extension) || url === Default;
  return { url, extension, isVideo, isImage, hasUploadedMedia };
};

export const getLeagueIconKey = (game) => {
  const desc = game?.description || "";
  const match = desc.match(ICON_MARKER_RE);
  if (!match) return null;
  const key = match[1].toLowerCase();
  return VALID_ICON_KEYS.has(key) ? key : null;
};

export const stripIconMarker = (description) =>
  (description || "").replace(ICON_MARKER_RE, "").trim();

export const buildDescriptionWithIcon = (description, iconKey) => {
  const stripped = stripIconMarker(description);
  if (!iconKey || !VALID_ICON_KEYS.has(iconKey)) return stripped;
  return `${stripped}<span data-qushi-icon="${iconKey}" style="display:none"></span>`;
};
